import momentJalaali from 'moment-jalaali'
import React, { useEffect, useState } from 'react'

import { DateObject } from '../../../helpers/date'
import { WalletInput, WalletType } from '../../../types/wallet'
import {
  Assignment,
  PaymentTermAssignmentRow
} from '../../../types/walletPaymentTerm'
import { PaymentTermAssignmentTable } from '../PaymentTermAssignmentTable'

interface StepThreePaymentTermAssignmentProps {
  setselectedWalletType: (walletType: WalletType) => void
  walletInput: WalletInput
  setwalletInput: React.Dispatch<React.SetStateAction<WalletInput>>
  selectedWalletType: WalletType | undefined
  coveringRange: DateObject
  setcoveringRange: React.Dispatch<React.SetStateAction<DateObject>>
  sethasFinishedAssigning: React.Dispatch<React.SetStateAction<boolean>>
}
const StepThreePaymentTermAssignment: React.FC<
  StepThreePaymentTermAssignmentProps
> = ({
  walletInput,
  selectedWalletType,
  coveringRange,
  setcoveringRange,
  setwalletInput,
  sethasFinishedAssigning
}) => {
  const [assignment, setassignment] = useState<PaymentTermAssignmentRow[]>()
  useEffect(() => {
    if (selectedWalletType?.isBilateral) {
      setassignment(
        walletInput.creditors.map(
          (creditor, index) =>
            ({
              assignments: creditor.paymentTermAssignment.map((as) => ({
                assignmentTimeRange: {
                  from: as.assignmentRange.from,
                  to: as.assignmentRange.to
                },
                paymentTermID: as.paymentTermID,
                paymentTermCode: as.paymentTermCode,
                paymentTermName: as.paymentTermName
              })),
              entity: {
                entityCode: creditor.entity.entityCode,
                entityID: creditor.entity.entityID,
                entityName: creditor.entity.entityName,
                entityType: creditor.entity.entityType
              },
              id: String(index)
            } as PaymentTermAssignmentRow)
        )
      )
    } else {
      setassignment([
        {
          assignments:
            walletInput.paymentTermAssignment.map((as) => ({
              assignmentTimeRange: {
                from: as.assignmentRange.from,
                to: as.assignmentRange.to
              },
              paymentTermID: as.paymentTermID,
              paymentTermCode: as.paymentTermCode,
              paymentTermName: as.paymentTermName
            })) || [],
          entity: {
            entityCode: walletInput.entity.entityCode || '',
            entityID: walletInput.entity.entityID,
            entityName: walletInput.entity.entityName || '',
            entityType: walletInput.entity.entityType
          },
          id: ''
        } as PaymentTermAssignmentRow
      ])
    }
  }, [selectedWalletType])
  useEffect(() => {
    if (selectedWalletType?.isBilateral) {
      setwalletInput((prev) => ({
        ...prev,
        creditors:
          prev.creditors?.map((creditor) => {
            // Find the corresponding assignment for this creditor
            const relevantAssignment = assignment?.find(
              (as) => as.entity.entityID === creditor.entity.entityID
            )

            return {
              ...creditor, // Retain existing creditor data
              paymentTermAssignment: relevantAssignment
                ? relevantAssignment.assignments.map((ass: Assignment) => ({
                    assignmentRange: {
                      from: ass.assignmentTimeRange.from,
                      to: ass.assignmentTimeRange.to
                    },
                    paymentTermID: ass.paymentTermID,
                    paymentTermCode: ass.paymentTermCode,
                    paymentTermName: ass.paymentTermName
                  }))
                : creditor.paymentTermAssignment // Keep previous assignment if no match
            }
          }) || []
      }))
      const allAssignmentsFinished = assignment?.every((as) => {
        const lastAssignmentEnd = as.assignments
          .map((assn) =>
            momentJalaali(assn.assignmentTimeRange.to, 'YYYY-MM-DD')
          )
          .reduce(
            (max, date) => (date.isAfter(max) ? date : max),
            momentJalaali(0)
          )

        return (
          lastAssignmentEnd?.format('YYYY-MM-DD') ===
          coveringRange.gregorianEndDate
        )
      })
      sethasFinishedAssigning(allAssignmentsFinished || false)
    } else {
      if (assignment && assignment?.length === 1) {
        setwalletInput({
          ...walletInput,
          paymentTermAssignment:
            assignment[0].assignments?.map((as: Assignment) => ({
              assignmentRange: {
                from:
                  as && as.assignmentTimeRange
                    ? as.assignmentTimeRange.from
                    : '',
                to:
                  as && as.assignmentTimeRange ? as.assignmentTimeRange.to : ''
              },
              //TODO: why payment term id is not there?
              paymentTermID: as ? as.paymentTermID : '',
              paymentTermCode: as ? as.paymentTermCode : '',
              paymentTermName: as ? as.paymentTermName : ''
            })) || []
        })

        const lastAssignmentEnd = assignment[0].assignments
          .map((assn) =>
            momentJalaali(assn.assignmentTimeRange.to, 'YYYY-MM-DD')
          )
          .reduce(
            (max, date) => (date.isAfter(max) ? date : max),
            momentJalaali(0)
          )

        sethasFinishedAssigning(
          lastAssignmentEnd?.format('YYYY-MM-DD') ===
            coveringRange.gregorianEndDate
        )
      }
    }
  }, [assignment])

  return (
    <div>
      <PaymentTermAssignmentTable
        assignments={assignment || []}
        setassignments={setassignment}
        coveringRange={coveringRange}
        setcoveringRange={setcoveringRange}
      />
    </div>
  )
}

export default StepThreePaymentTermAssignment
